import { defineMessages } from '@transcend-io/internationalization';

export const naMessages = defineMessages('ad-core-components.NA.na', {
  header: {
    defaultMessage: 'N/A',
  },
});
